<template>
  <div class="tab1">
    <!-- <el-form :inline="true" :model="thingFormInline" class="demo-form-inline" size="small" @submit.native.prevent>
      <el-form-item>
        <strong slot="label">名称</strong>
        <el-input v-model="thingFormInline.name" placeholder="请输入名称" clearable @keyup.enter.native="inquire" @clear="inquire"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form-item>
    </el-form> -->
      <el-button type="primary" plain size="small" icon="el-icon-plus" @click="handleAdd({bomId: 0})" v-if="judgeButton('bom')">新增</el-button>
      <el-button type="info" plain size="small" icon="el-icon-copy-document" @click="handleCopy" v-if="judgeButton('bom')">复制</el-button>
      <el-button type="primary" plain size="small" icon="el-icon-finished" @click="handleEditBatch({bomId: 0})" v-if="judgeButton('bom')">保存</el-button>
      <el-button type="danger" plain size="small" icon="el-icon-delete" @click="handleDelBatch" v-if="judgeButton('bom')" :disabled="!ids.length">删除</el-button>
      <el-button type="warning" plain size="small" @click="handleImport" icon="el-icon-upload2" v-if="judgeButton('bom')">导入</el-button>
      <el-button type="warning" plain size="small" @click="handleImportZnhw" icon="el-icon-upload2" v-if="judgeButton('bom') && isZnhw">导入【物料编码】</el-button>
      <el-button type="info" plain size="small" @click="handleBomHeader" icon="el-icon-time" v-if="judgeButton('bom')">历史版本</el-button>
      <el-button type="success" plain size="small" @click="handleExport" icon="el-icon-download">导出</el-button>
    <!-- <el-button type="success" plain size="small" icon="el-icon-edit" :disabled="!edit" @click="handleEdit">编辑</el-button>
    <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="!del" @click="handleDel">删除</el-button> -->
    <div style="margin: 10px 0 0 0" v-if="bomHeader.version">
      <el-tag>BOM版本：v{{bomHeader.version}}</el-tag>
    </div>
    <el-table
      :data="tableData"
      tooltip-effect="dark"
      ref="multipleTable"
      style="width: 100%;margin-top:16px"
      @selection-change="handleSelectionChange"
      :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
      v-loading="loading"
      row-key="bomId"
      :default-expand-all="false"
      :tree-props="{children: 'children'}"
      :key="tableKey"
      @expand-change="handleExpandChange"
      :summary-method="(param) => getSummaries(param, ['quantity', 'price','cost'])"
      show-summary>
      <el-table-column
        type="selection"
        width="75">
      </el-table-column>
      <el-table-column
        prop="xh"
        :width="xhMaxLen"
        label="行号">
        <template slot-scope="scope">
          {{ scope.row.xh }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="资源名称"
        width="250">
        <template slot-scope="scope">
          <span class="drag-handle">↕</span>
          <a v-if="scope.row.xpj == '0'" @click="handleView(scope.row)" class="link">{{scope.row.name}}</a>
          <a v-else>{{scope.row.name}}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="ggxh"
        label="规格型号"
        width="200" show-overflow-tooltip />
      <el-table-column
        label="使用数量"
        prop="quantity"
        width="120"
        align="right"
        header-align="center">
        <template slot="header">
          <el-popover
            placement="right"
            width="160"
            trigger="click"
            ref="popover">
            <el-input size="mini" v-model="bzslmdw" clearable></el-input>
            <div style="text-align: right; margin-top: 10px">
              <el-button type="primary" size="mini" @click="submitBzslmdw('table', 'quantity')">确 定</el-button>
            </div>
            <!-- <a slot="reference" class="vatgroup" @click="configValue = ''"> -->
            <!-- {{item.name}}</a> -->
            <a slot="reference" class="link" @click="bzslmdw = ''">使用数量
              <i class="el-icon-edit-outline"></i>
            </a>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.quantity"
            size="mini"
            class="right-input"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="jldw"
        label="计量单位"
        width="120" />
      <el-table-column
        label="基本用量"
        prop="bomsl"
        width="120"
        align="right"
        header-align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.bomsl"
            size="mini"
            class="right-input"
            @input="handleCalcQuantity(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="基础数量"
        prop="bzslmdw"
        width="140"
        align="right"
        header-align="center">
        <template slot="header">
          <el-popover
            placement="right"
            width="160"
            trigger="click"
            ref="popover">
            <el-input size="mini" v-model="bzslmdw" clearable></el-input>
            <div style="text-align: right; margin-top: 10px">
              <el-button type="primary" size="mini" @click="submitBzslmdw('table', 'bzslmdw')">确 定</el-button>
            </div>
            <!-- <a slot="reference" class="vatgroup" @click="configValue = ''"> -->
              <!-- {{item.name}}</a> -->
            <a slot="reference" class="link" @click="bzslmdw = ''">基础数量
              <i class="el-icon-edit-outline"></i>
            </a>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.bzslmdw"
            size="mini"
            class="right-input"
            @input="handleCalcQuantity(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="金额"
        prop="price"
        width="120"
        align="right"
        header-align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.price"
            size="mini"
            class="right-input"
          ></el-input>
        </template>
        <!-- <template slot-scope="scope">
          {{scope.row.price | comdify('no')}}
        </template> -->
      </el-table-column>
      <el-table-column
        label="成本"
        prop="cost"
        width="120"
        align="right" v-if="judgeButton2('bom:cost')"
        header-align="center" />
      <el-table-column
        label="损耗率"
        prop="lossRate"
        width="125">
        <template slot-scope="scope">
          <!-- {{scope.row.lossRate ? scope.row.lossRate + '%' : ''}} -->
          <el-input
            v-model="scope.row.lossRate"
            size="mini"
            class="right-input"
          >
            <template slot="append">%</template>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="描述"
        prop="remark"
        width="340"
        show-overflow-tooltip>
        <template slot="header">
          <el-popover
            placement="right"
            width="160"
            trigger="click"
            ref="dialogPopover">
            <el-input size="mini" v-model="bzslmdw" clearable></el-input>
            <div style="text-align: right; margin-top: 10px">
              <el-button type="primary" size="mini" @click="submitBzslmdw('table', 'remark')">确 定</el-button>
            </div>
            <a slot="reference" class="link" @click="bzslmdw = ''">描述
              <i class="el-icon-edit-outline"></i>
            </a>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <!-- {{scope.row.lossRate ? scope.row.lossRate + '%' : ''}} -->
          <el-input
            v-model="scope.row.remark"
            size="mini"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="jc"
        label="简称"
        min-width="200">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.jc"
            size="mini"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.sort"
            size="mini"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        v-if="judgeButton('bom')"
        width="170">
        <template slot-scope="scope">
          <el-button
            size="mini" icon="el-icon-plus" type="text"
            @click="handleAdd(scope.row)">新增</el-button>
          <el-button
            size="mini" icon="el-icon-edit" type="text"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini" icon="el-icon-delete" type="text"
            @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        style="max-height: 50vh; overflow-y: auto;overflow-x:hidden"
        label-width="110px"
        size="small"
      >
        <!-- <el-form-item label="资源" prop="ofrResourceId"> -->
        <el-form-item v-if="ruleForm.bomId" label="资源" prop="ofrResourceId">
          <el-input
            :value="getOfrResource(ruleForm.ofrResourceId, 'remarks') || ''"
            placeholder="请选择资源"
            readonly
          >
            <el-button slot="append" @click="openResDialog(true)">切换资源</el-button>
          </el-input>
        </el-form-item>
        <el-form-item v-else label="资源" prop="ofrResourceIds">
          <el-select v-model="ruleForm.ofrResourceIds" placeholder="请选择资源" filterable style="width: 100%" multiple>
            <el-option-group
              v-for="(group, index) in resTreeList"
              :key="index"
              :label="group.name">
              <el-option
                v-for="item in group.resourceList"
                :key="item.ofrResourceId"
                :label="item.remarks"
                :value="item.ofrResourceId">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="父级" prop="pid">
          <treeselect v-model="ruleForm.pid" :options="options" :normalizer="normalizer" placeholder="请选择父级" />
        </el-form-item>
        <el-form-item label="使用数量" prop="quantity">
          <el-input
            v-model="ruleForm.quantity"
            :placeholder="`请输入使用数量`"
          ></el-input>
        </el-form-item>
        <el-form-item label="基本用量" prop="bomsl">
          <el-input
            v-model="ruleForm.bomsl"
            :placeholder="`请输入基本用量`"
            @input="handleCalcQuantity(ruleForm)"
          ></el-input>
        </el-form-item>
        <el-form-item label="基础数量" prop="bzslmdw">
          <el-input
            v-model="ruleForm.bzslmdw"
            :placeholder="`基础数量`"
            @input="handleCalcQuantity(ruleForm)"
          ></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="price">
          <el-input
            v-model="ruleForm.price"
            :placeholder="`请输入金额`"
          ></el-input>
        </el-form-item>
        <el-form-item label="损耗率" prop="lossRate">
          <el-input
            v-model="ruleForm.lossRate"
            type="number"
            :placeholder="`请输入损耗率`"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input
            v-model="ruleForm.remark"
            :placeholder="`请输入描述`"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="简称" prop="jc">
          <el-input
            v-model="ruleForm.jc"
            :placeholder="`请输入简称`"
          ></el-input>
        </el-form-item>
        <el-form-item label="选配件" prop="xpj">
          <el-checkbox v-model="ruleForm.xpj" true-label="0" false-label="1"></el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 新增Bom（大） -->
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogAddVisible"
      :append-to-body="true"
      width="90%"
    >
      <el-button size="small" type="primary" @click="clickRes" style="margin-bottom:10px">选择资源</el-button>
      <!-- <el-select v-model="ofrResourceIds" placeholder="请选择资源" filterable style="width: 100%" multiple size="small" @change="changeRes">
        <el-option-group
          v-for="(group, index) in resTreeList"
          :key="index"
          :label="group.name">
          <el-option
            v-for="item in group.resourceList"
            :key="item.ofrResourceId"
            :label="item.remarks"
            :value="item.ofrResourceId">
          </el-option>
        </el-option-group>
      </el-select> -->
      <el-table
        style="width: 100%"
        :data="bomData"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        border
        :summary-method="(param) => getSummaries(param, ['quantity', 'price'])"
        show-summary>
        <!-- 资源 -->
        <el-table-column
          prop="ofrResourceName"
          label="资源"
          width="250">
          <!-- <template slot-scope="scope">
            <a class="link">
              {{scope.row.ofrResourceName}}
            </a>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="ggxh"
          label="规格型号"
          width="180" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="jldw"
          label="计量单位"
          width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="pName"
          label="父级">
          <template slot-scope="scope">
            <a class="link" @click="clickP(scope.row.pid, scope.$index)">
              {{scope.row.pName}}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          label="使用数量"
          prop="quantity"
          width="120"
          align="right"
          header-align="center">
          <template slot="header">
            <el-popover
              placement="right"
              width="160"
              trigger="click"
              ref="dialogPopover">
              <el-input size="mini" v-model="bzslmdw" clearable></el-input>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitBzslmdw('dialog', 'quantity')">确 定</el-button>
              </div>
              <a slot="reference" class="link" @click="bzslmdw = ''">使用数量
                <i class="el-icon-edit-outline"></i>
              </a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.quantity"
              size="mini"
              class="right-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="基本用量"
          prop="bomsl"
          width="120"
          align="right"
          header-align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bomsl"
              size="mini"
              class="right-input"
              @input="handleCalcQuantity(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="基础数量"
          prop="bzslmdw"
          width="140"
          align="right"
          header-align="center">
          <template slot="header">
            <el-popover
              placement="right"
              width="160"
              trigger="click"
              ref="dialogPopover">
              <el-input size="mini" v-model="bzslmdw" clearable></el-input>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitBzslmdw('dialog', 'bzslmdw')">确 定</el-button>
              </div>
              <!-- <a slot="reference" class="vatgroup" @click="configValue = ''"> -->
                <!-- {{item.name}}</a> -->
              <a slot="reference" class="link" @click="bzslmdw = ''">基础数量
                <i class="el-icon-edit-outline"></i>
              </a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bzslmdw"
              size="mini"
              class="right-input"
              @input="handleCalcQuantity(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="quantity"
          label="数量"
          align="right"
          header-align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.quantity"
              size="mini"
              clearable
              class="right-input"
            ></el-input>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="price"
          label="金额"
          align="right"
          header-align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.price"
              size="mini"
              clearable
              class="right-input"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="lossRate"
          label="损耗率">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.lossRate"
              size="mini"
              clearable
              class="right-input"
            >
              <template slot="append">%</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="描述">
          <template slot="header">
            <el-popover
              placement="right"
              width="160"
              trigger="click"
              ref="dialogPopover">
              <el-input size="mini" v-model="bzslmdw" clearable></el-input>
              <div style="text-align: right; margin-top: 10px">
                <el-button type="primary" size="mini" @click="submitBzslmdw('dialog', 'remark')">确 定</el-button>
              </div>
              <a slot="reference" class="link" @click="bzslmdw = ''">描述
                <i class="el-icon-edit-outline"></i>
              </a>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.remark"
              size="mini"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="jc"
          label="简称">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.jc"
              size="mini"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          width="100"
          label="排序">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sort"
              size="mini"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="addChild"
          label="带入物料">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.addChild" ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="xpj"
          label="选配件">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.xpj" true-label="0" false-label="1"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
          fixed="right"
          align="right"
          >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDelete(scope.row, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm1" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 复制BOM -->
    <el-dialog v-dialog-drag
      title="复制BOM"
      :visible.sync="dialogCopyVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="formCopy"
        :rules="rules"
        ref="formCopy"
        class="demo-ruleForm"
        style="max-height: 50vh; overflow-y: auto;overflow-x:hidden"
        label-width="60px"
      >
        <el-form-item label="资源" prop="ofrResourceId">
          <el-select v-model="formCopy.ofrResourceId" placeholder="请选择资源" filterable style="width: 100%">
            <el-option-group
              v-for="(group, index) in copyFormResources"
              :key="index"
              :label="group.name">
              <el-option
                v-for="item in group.resourceList"
                :key="item.ofrResourceId"
                :label="item.remarks + (item.ggxh?'['+item.ggxh+']':'') + (item.jldw?'['+item.jldw+']':'')"
                :value="item.ofrResourceId">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCopyVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCopyForm('formCopy')" :loading="isLoading">确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 导入BOM -->
    <el-dialog v-dialog-drag
      :title="`导入BOM`"
      :visible.sync="dialogImportVisible"
      width="30%"
      append-to-body
      top="59px"
      class="res-dialog"
      >
      <el-upload
        class="upload-demo"
        :auto-upload="false"
        drag
        action="#"
        multiple
        accept=".xlsx, .xls"
        :show-file-list="false"
        :on-change="handleChange">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="exportBtn">下载模板</el-link>
        </div>
      </el-upload>
      <!-- <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <el-checkbox v-model="done" style="margin-top:10px">是否正式</el-checkbox> -->
      <!-- <span style="margin-top:10px;color:red;display:inline-block">注：黄色字体表示选中多条资源</span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImportVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialog-drag
      :title="`导入BOM`"
      :visible.sync="dialogImportZnhwVisible"
      width="30%"
      append-to-body
      top="59px"
      class="res-dialog"
      >
      <el-upload
        class="upload-demo"
        :auto-upload="false"
        drag
        action="#"
        multiple
        accept=".xlsx, .xls"
        :show-file-list="false"
        :on-change="handleZnhwChange">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="exportBtnZnhw">下载模板</el-link>
        </div>
      </el-upload>
      <!-- <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <el-checkbox v-model="done" style="margin-top:10px">是否正式</el-checkbox> -->
      <!-- <span style="margin-top:10px;color:red;display:inline-block">注：黄色字体表示选中多条资源</span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImportZnhwVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 选择资源 -->
    <el-dialog v-dialog-drag
      title="选择资源"
      :visible.sync="dialogResVisible"
      :append-to-body="true"
      width="80%"
      top="59px"
      class="res-dialog"
    >
      <div style="margin-bottom: 10px">
        <el-select v-model="cbRestypeId" @change="changeCbRestype" size="small">
          <el-option
            v-for="item in resTypeList"
            :key="item.cbRestypeId"
            :label="item.name"
            :value="item.cbRestypeId">
          </el-option>
        </el-select>
        <el-input size="small" style="width:300px;margin-left:16px" v-model="mcsearch" @keydown.enter.native="searchChange" placeholder="输入名称搜索" clearable/>
        <el-input size="small" style="width:300px;margin-left:16px" v-model="ggsearch" @keydown.enter.native="searchChange" placeholder="输入规格型号搜索" clearable/>
        <el-button style="margin-left: 10px;" type="primary" @click="searchChange" size="mini">搜索</el-button>
        <el-button style="margin-left: 10px;" type="primary" @click="resetQuery()" size="mini">重置</el-button>
      </div>
      <div style="display: flex">
        <div class="left" ref="querytree">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="item.label" :name="index + 1" v-for="(item, index) in cbussDimeTree" :key="index">
              <el-tree
                :data="item.children"
                :props="{
                  children: 'children',
                  label: 'label'
                }"
                @node-click="handleNodeClick($event, index)"
                default-expand-all
                :ref="'tree' + (index + 1)"
                :expand-on-click-node="false"
                highlight-current
                node-key="value">
              </el-tree>
            </el-collapse-item>
          </el-collapse>
          <!-- <el-tree
            ref="resTypeTree"
            :data="resTypeList"
            :props="{
              children: 'children',
              label: 'name'
            }"
            @node-click="handleNodeClick"
            highlight-current
            node-key="cbRestypeId"></el-tree> -->
        </div>
        <div style="flex:1;overflow: auto">
          <el-table
            ref="restypeTable"
            :key="resSelectSingle ? 'resource-single' : 'resource-multi'"
            :data="resList"
            tooltip-effect="dark"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
            style="width: 100%"
            @selection-change="handleResSelectionChange"
            @row-click="clickRowRes"
            size="small"
            v-loading="tableLoading"
            :height="tableHeight"
            row-key="ofrResourceId"
            @sort-change="handleResSortChange"
            >

            <el-table-column
              v-if="!resSelectSingle"
              type="selection"
              :reserve-selection="true"
              width="55">
            </el-table-column>
            <el-table-column
              v-else
              label="选择"
              width="70"
              align="center">
              <template slot-scope="scope">
                <el-radio v-model="singleResId" :label="scope.row.ofrResourceId"><i></i></el-radio>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="资源种类"
              prop="restypeName"
              width="150">
            </el-table-column> -->
            <el-table-column
              label="描述"
              prop="remarks">
            </el-table-column>
            <el-table-column
              label="名称"
              prop="resourceName">
            </el-table-column>
            <el-table-column
              label="规格型号"
              prop="ggxh"
              width="100">
            </el-table-column>
            <el-table-column
              label="单位"
              prop="jldw"
              width="100">
            </el-table-column>
            <el-table-column
              v-for="(item, index) in resDimeList"
              v-if="item.columnshow == '0'"
              :key="item.cbdId || index"
              :label="item.dimeName"
              :column-key="index + ''"
              :sortable="item.isSort == '0' ? 'custom' : false"
              width="150">
              <template slot-scope="scope">
                <div v-for="(val, id) in scope.row.obussDimeList" :key="id" v-if="item.cbdId == val.cbdId">{{val.dimeText}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="库存"
              prop="ofrOwhResourceList">
              <template slot-scope="scope">
                <el-row :key="item.owhName" v-for="item in scope.row.ofrOwhResourceList">
                  <el-col :span="12">{{item.owhName}}：</el-col>
                  <el-col :span="12">{{item.resourceQuantity}}</el-col>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>


      <el-pagination
        :current-page="pageinfo.pageNum"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageinfo.pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="pageinfo.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="margin-bottom: 3px"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogResVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRes">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialog-drag
      title="BOM历史版本"
      :visible.sync="dialogBomHeaderVisible"
      :append-to-body="true"
      width="680px"
    >
      <el-table
        :data="bomHeaderList"
        tooltip-effect="dark"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        style="width: 100%"
        size="small"
        v-loading="bomHeaderLoading">
        <el-table-column label="选择" width="70" align="center">
          <template slot-scope="scope">
            <el-radio v-model="selectedBomHeaderId" :label="scope.row.id"><i></i></el-radio>
          </template>
        </el-table-column>
        <el-table-column label="版本号" width="120">
          <template slot-scope="scope">
            v{{ scope.row.version || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.isDefault === 'Y'">当前版本</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="180" />
        <el-table-column label="描述" prop="description" show-overflow-tooltip />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBomHeaderVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitChangeBomHeader" :disabled="!selectedBomHeaderId">变更版本</el-button>
        <el-button type="success" @click="submitCreateBomHeader" :disabled="!selectedBomHeaderId">生成新版本</el-button>
      </div>
    </el-dialog>
    <!-- 选择父级 -->
    <el-dialog v-dialog-drag
      title="选择父级"
      :visible.sync="dialogPVisible"
      :append-to-body="true"
      width="500px"
    >
      <treeselect v-model="pid1" :options="options" :normalizer="normalizer" placeholder="请选择父级" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitP">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选配件列表 -->
    <el-dialog v-dialog-drag
      :title="viewTitle"
      :visible.sync="dialogViewVisible"
      :append-to-body="true"
      width="80%"
      top="59px"
      class="res-dialog"
    >
      <el-button type="primary" plain size="small" icon="el-icon-plus" @click="handleAddXpj">新增</el-button>
      <el-button type="danger" plain size="small" icon="el-icon-delete" @click="handleDelXpj" :disabled="!xpjIds.length">删除</el-button>
      <el-table
        :data="xpjList"
        tooltip-effect="dark"
        style="width: 100%;margin-top:16px"
        @selection-change="handleXpjSelectionChange"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
        v-loading="xpjLoading">
        <el-table-column
          type="selection"
          width="75">
        </el-table-column>
        <!-- <el-table-column
          type="index"
          width="55"
          label="行号">
        </el-table-column> -->
        <el-table-column
          label="描述"
          prop="remarks">
        </el-table-column>
        <el-table-column
          label="名称"
          prop="resourceName">
        </el-table-column>
        <el-table-column
          label="规格型号"
          prop="ggxh"
          width="100">
        </el-table-column>
        <el-table-column
          label="单位"
          prop="jldw"
          width="100">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogViewVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="submitP">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import {mapState} from 'vuex'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Sortable from 'sortablejs'
  export default {
    props: {
      contentData: {
        type: Object,
        default: {}
      }
    },
    components: {
      Treeselect
    },
    computed: {
      ...mapState({
        dropDown: state => state.dropDown.dropDown,
        currentMenu: (state) => state.tags.currentMenu
      })
    },
    data() {
      return {
        btnMenu: JSON.parse(window.sessionStorage.getItem('btnMenu')),
        // 中农华威
        isZnhw: false,
        dialogFormVisible: false,
        ruleForm: {},
        formCopy: {},
        rules: {
          ofrResourceId: [{ required: true, message: '请选择资源', trigger: "change" }],
          ofrResourceIds: [{ required: true, message: '请选择资源', trigger: "change" }]
        },
        bomHeader: {},
        bomHeaderList: [],
        bomHeaderLoading: false,
        dialogBomHeaderVisible: false,
        selectedBomHeaderId: null,
        // 弹出层标题
        title: '',
        loading: true,
        tableData: [],
        bomsort: 1,
        tableKey: 0, // 用于强制重新渲染的 key
        isLoading: false,
        resTreeList: [],
        // 树选项
        options: [],
        dialogCopyVisible: false,
        copyFormResources: [],
        dialogImportVisible: false,
        dialogImportZnhwVisible: false,
        dialogAddVisible: false,
        bomData: [],
        ofrResourceIds: [],
        pid: null,
        dialogResVisible: false,
        pName: null,
        pid1: null,
        dialogPVisible: false,
        index: null,
        ids: [],
        search: '',
        resList: [],
        tableLoading: false,
        tableHeight: 0,
        pageinfo: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        },
        bzslmdw: '',
        viewTitle: '',
        dialogViewVisible: false,
        xpjIds: [],
        xpjList: [],
        xpjLoading: false,
        isXpj: false,
        xpjBomId: '',
        resTypeList: [],
        cbRestypeId: 0,
        mcsearch: '',
        ggsearch: '',
        activeNames: [],
        cbussDimeTree: [],
        resDimeList: [],
        resSortDime: null,
        resSelectSingle: false,
        singleResId: null,
        xhMaxLen: 0,
        originalData: null,
        expandedRowKeys: new Set()
      }
    },
    created () {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 300;
      })
    },
    mounted() {
      console.log('----')
      this.getDefaultBomHeader()
      this.getList()
      this.getResTypeResource()

      const loginUser = JSON.parse(window.sessionStorage.getItem('loginUser'))
      if(loginUser.orgId === 177) {
        this.isZnhw = true
      }else{
        this.isZnhw = false
      }
      // this.initSortable()
    },
    methods: {
    /* ------------拖拽排序----------------- */
      initSortable() {
        this.$nextTick(() => {
          setTimeout(() => {
            const table = this.$refs.multipleTable
            if (!table) return

            const wrapper = table.$el.querySelector('.el-table__body-wrapper tbody')
            if (!wrapper) return

            this.createSortableInstance(wrapper)
          }, 500)
        })
      },

      createSortableInstance(wrapper) {
        if (this.sortable) {
          this.sortable.destroy()
        }
        this.sortable = Sortable.create(wrapper, {
          handle: '.drag-handle',
          animation: 150,
          ghostClass: 'sortable-ghost',
          onStart: () => {
            this.setAllRowDataIds()
            this.saveExpandedState()
          },
          onEnd: (evt) => {
            const { oldIndex, newIndex } = evt
            this.handleDragSort(oldIndex, newIndex)
          }
        })
      },

      // 设置行的 data-id
      setAllRowDataIds() {
        const table = this.$refs.multipleTable
        if (!table) return

        const wrapper = table.$el.querySelector('.el-table__body-wrapper tbody')
        if (!wrapper) return

        const rows = wrapper.querySelectorAll('tr')
        console.log(rows)
        const flatData = this.getFlatDataWithLevels()

        rows.forEach((row, index) => {
          if (index < flatData.length) {
            const node = flatData[index]
            row.setAttribute('data-id', node.id)
          }
        })
      },

      // 获取扁平化数据
      getFlatDataWithLevels() {
        const result = []

        const flatten = (nodes, level = 0, parent = null) => {
          nodes.forEach(node => {
            result.push({
              ...node,
              _level: level,
              _parent: parent
            })

            if (node.children && node.children.length > 0) {
              flatten(node.children, level + 1, node)
            }
          })
        }

        flatten(this.tableData)
        return result
      },

      // 处理拖拽排序
      handleDragSort(oldIndex, newIndex) {
        try {
          const flatData = this.getFlatDataWithLevels()
          console.log('handleDragSort')
          if (oldIndex >= flatData.length || newIndex >= flatData.length) {
            throw new Error('索引超出范围')
          }

          const draggedItem = flatData[oldIndex]
          const targetItem = flatData[newIndex]

          // 检查是否在同一层级
          if (draggedItem._level !== targetItem._level) {
            this.$message.warning('只能在同层级内拖拽排序')
            this.restoreTable()
            return
          }

          // 执行排序
          this.performSort(draggedItem, targetItem, oldIndex < newIndex)
          this.$message.success('排序成功，保存后生效！')

        } catch (error) {
          console.error('排序失败:', error)
          this.$message.error('排序失败')
          this.restoreTable()
        }
      },

      // 执行排序操作
      performSort(draggedItem, targetItem, movingDown) {
        const targetArray = draggedItem._parent ? draggedItem._parent.children : this.tableData

        const draggedIndex = targetArray.findIndex(item => item.bomId === draggedItem.bomId)
        const targetIndex = targetArray.findIndex(item => item.bomId === targetItem.bomId)

        if (draggedIndex === -1 || targetIndex === -1) {
          throw new Error('未找到节点位置')
        }

        // 执行移动
        const [movedItem] = targetArray.splice(draggedIndex, 1)

        let newIndex = targetIndex
        if (draggedIndex < targetIndex) {
          newIndex = movingDown ? targetIndex : targetIndex - 1
        } else {
          newIndex = movingDown ? targetIndex + 1 : targetIndex
        }

        newIndex = Math.max(0, Math.min(newIndex, targetArray.length))
        targetArray.splice(newIndex, 0, movedItem)

        // 关键：强制表格重新渲染
        this.refreshTable()
      },

      // 刷新表格的几种方法
      refreshTable() {
        // 方法1：通过改变 key 强制重新渲染（推荐）
        this.tableKey += 1

        // 方法2：重新设置数据（备用）
        // this.reassignTableData()
        this.restoreExpandedState()
        // 方法3：使用 $nextTick 确保 DOM 更新
        this.$nextTick(() => {
          // 重新初始化拖拽
          setTimeout(() => {
            this.initSortable()
          }, 100)
        })
      },

      // 方法2：重新分配数据
      reassignTableData() {
        this.tableData = JSON.parse(JSON.stringify(this.tableData))
      },

      // 恢复表格
      restoreTable() {
        this.tableData = JSON.parse(JSON.stringify(this.originalData))
        this.refreshTable()
      },
      // 保存当前展开状态
      saveExpandedState() {

      },
      // 展开/收起事件
      handleExpandChange(row, expanded) {
        if (expanded) {
          this.expandedRowKeys.add(row.bomId)
        } else {
          this.expandedRowKeys.delete(row.bomId)
        }
      },
      // 恢复展开状态
      restoreExpandedState() {
        this.$nextTick(() => {
          const table = this.$refs.multipleTable
          if (!table) return
          console.log(4321)
          // 延迟恢复展开状态，确保表格已渲染
          setTimeout(() => {
            this.expandedRowKeys.forEach(bomId => {
              const node = this.findNodeByBomId(this.tableData, bomId)
              if (node) {
                table.toggleRowExpansion(node, true)
              }
            })
          }, 200)
        })
      },

// 根据 bomId 查找节点
      findNodeByBomId(nodes, bomId) {
        for (const node of nodes) {
          if (node.bomId === bomId) return node
          if (node.children) {
            const found = this.findNodeByBomId(node.children, bomId)
            if (found) return found
          }
        }
        return null
      },
    /* -------------------------------------- */
      changeCbRestype(e) {
        this.cbRestypeId = e
        this.pageinfo.pageNum = 1
        this.cbussDimeTree = []
        this.resDimeList = []
        this.resSortDime = null
        this.$nextTick(() => {
          if (this.$refs.restypeTable) {
            this.$refs.restypeTable.clearSort()
          }
        })
        this.getOfrResourceList()
        this.getCbussDimeList()
      },
      // 获取资源列表
      getOfrResourceList() {
        this.tableLoading = true
        const cbussDimeList = this.cbussDimeTree.filter(item => item.value).map(item => {
          return {
            cbdId: item.cbdId,
            editType: item.editType,
            resourceType: item.resourceType,
            value: item.value,
            endValue: ''
          }
        })
        this.cbussDimeTree.forEach(item => {
          if (item.editType == '4' || item.editType == '5' || item.editType == '9' || item.editType == '10' || item.editType == '11') {
            if (item.showValue && item.showValue.length) {
              cbussDimeList.push({
                cbdId: item.cbdId,
                editType: item.editType,
                resourceType: item.resourceType,
                value: item.showValue[0],
                endValue: item.showValue[1]
              })
            }
          } else {
            if (item.showValue) {
              cbussDimeList.push({
                cbdId: item.cbdId,
                editType: item.editType,
                resourceType: item.resourceType,
                value: item.showValue,
                endValue: ''
              })
            }
          }
        })
        this.$http.post(url.OfrResourceList, {
          cbRestypeId: this.cbRestypeId,
          pageNum: this.pageinfo.pageNum,
          pageSize: this.pageinfo.pageSize,
          cbussDimeList,
          resourceName: this.mcsearch,
          ggxh: this.ggsearch,
          sortParams: this.resSortDime ? JSON.stringify([this.resSortDime]) : ''
          // : cbussDimeList.length ? JSON.stringify(cbussDimeList) : ''
        }).then(res => {
          if (res.data.code == 200) {
            this.resList = res.data.data.list
            this.pageinfo.total = res.data.data.total
          }
        }).finally(() => {
          this.tableLoading = false
        })
      },
      // 获取资源维度列表
      getCbussDimeList() {
        this.cbussDimeTree = []
        this.activeNames = []
        this.resDimeList = []
        this.$http.get(url.getCbussDimeList, { params: { cbussId: this.cbRestypeId, dimetype: '1' } }).then(res => {
          this.resDimeList = res.data.data || []
          const resDimeList = this.resDimeList.filter(item => item.isQuery == '0')
          resDimeList.forEach(item => {
            if (item.editType == '3' || item.editType == '6' || item.editType == '7' || item.editType == '20') {
              if(item.editType == '20') {
                item.children = this.getTree(JSON.parse(item.options))
              }else {
                item.children = JSON.parse(item.options).map(val => {
                  return {
                    label: val.optionLabel,
                    value: val.optionValue
                  }
                })
              }
              item.label = item.dimeName
              this.cbussDimeTree.push(item)
            }
          })
          if (this.cbussDimeTree.length === 0) {
            this.$nextTick(() => {
              this.$refs.querytree.style.width = 0
            })
            // this.$refs.querytree.style.width = 0
          }else {
            this.$nextTick(() => {
              this.$refs.querytree.style.width = '180px'
            })
            //
          }
          this.cbussDimeTree.forEach((item, index) => {
            this.activeNames.push(index + 1)
          })
        })
      },
      getTree(tree) {
        let arr = [];
        if (tree.length !== 0) {
          tree.forEach(item => {
            let obj = {};
            obj.label = item.optionLabel;
            obj.value = item.optionValue;
            if (item.children && item.children.length > 0) {
              obj.children = this.getTree(item.children);
            }
            arr.push(obj);
          });
        }
        return arr
      },
      handleNodeClick(e, index) {
        // console.log(data);
        // this.cbussDimeTree[index].value = this.cbussDimeTree[index].value ? '' : e.value
        this.cbussDimeTree[index].value = this.cbussDimeTree[index].value == e.value ? '' : e.value
        if(!this.cbussDimeTree[index].value) {
          this.$nextTick(() => {
            this.$refs['tree' + (index + 1)][0].setCurrentKey(null)
          })
        }

        this.pageinfo.pageNum = 1
        this.getOfrResourceList()
      },
      handleResSortChange({ column, order }) {
        if (!order || !column) {
          this.resSortDime = null
        } else {
          const current = this.resDimeList[Number(column.columnKey)]
          this.resSortDime = current ? {
            ...current,
            sortValue: order == 'ascending' ? 'asc' : 'desc'
          } : null
        }
        this.pageinfo.pageNum = 1
        this.getOfrResourceList()
      },
      handleView(row) {
        // console.log(row);
        this.viewTitle = row.name
        this.xpjBomId = row.bomId
        this.dialogViewVisible = true
        this.selectBomXpj()

      },
      selectBomXpj() {
        this.xpjLoading = true
        this.$http.get(url.selectBomXpj + this.xpjBomId).then(res => {
          this.xpjLoading = false
          if(res.data.code === 200) {
            // console.log(res.data);
            this.xpjList = res.data.data
          }
        })
      },
      handleAddXpj() {
        this.openResDialog(false, true)
      },
      handleDelXpj() {
        this.ofrResourceIds = this.xpjList.map(item => item.ofrResourceId).filter(item => !this.xpjIds.includes(item))
        // console.log(this.ofrResourceIds);
        this.xpjList = this.xpjList.filter(item => !this.xpjIds.includes(item.ofrResourceId))
        // this.xpjList
        this.handleXpj()
      },
      async handleXpj() {
        await this.$http.get(url.bomDetail + this.xpjBomId).then(res => {
          if(res.data.code === 200) {
            this.ruleForm = res.data.data
            this.ruleForm.ofrResourceIds = []
            let xpjIds = this.xpjList.map(item => item.ofrResourceId)
            this.ruleForm.xpjIds = Array.from(new Set(JSON.parse(JSON.stringify([...this.ofrResourceIds, ...xpjIds])))).toString()
          }
        })
        let query = JSON.parse(JSON.stringify(this.ruleForm))
        query.ofrResourceIds = query.ofrResourceIds.toString()
        await this.$http.post(url.editBomResource, query).then(res => {
          if(res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.selectBomXpj()
          }
        })
      },
      handleXpjSelectionChange(rows) {
        this.xpjIds = JSON.parse(JSON.stringify(rows.map(item => item.ofrResourceId)))
      },

      // 一键编辑包装数量
      submitBzslmdw(type, key) {
        if(type == 'dialog') {
          this.$nextTick(() => {
            this.$refs.dialogPopover.showPopper = false
          })
          this.setBzslmdw(this.bomData, key)
        }else {
          this.$nextTick(() => {
            this.$refs.popover.showPopper = false
          })
          this.setBzslmdw(this.tableData, key)
        }

      },

      // // 一键编辑包装数量
      // submitBzslmdw(type) {
      //   if(type == 'dialog') {
      //     this.$nextTick(() => {
      //       this.$refs.dialogPopover.showPopper = false
      //     })
      //     this.setBzslmdw(this.bomData)
      //   }else {
      //     this.$nextTick(() => {
      //       this.$refs.popover.showPopper = false
      //     })
      //     this.setBzslmdw(this.tableData)
      //   }

      // },
      setBzslmdw(list, key) {
        list.forEach(item => {
          item[key] = this.bzslmdw
          this.handleCalcQuantity(item)
          if(item.children && item.children.length) {
            this.setBzslmdw(item.children, key)
          }
        })
      },
      // 计算核算数量
      handleCalcQuantity(row) {
        if(row.bomsl && row.bzslmdw) {
          row.quantity = row.bomsl / row.bzslmdw
        }
      },
      resetQuery(){
        this.mcsearch = ''
        this.ggsearch = ''
        this.resSortDime = null
        if (this.$refs.restypeTable) {
          this.$refs.restypeTable.clearSort()
        }
        this.searchChange()
      },
      searchChange() {
        this.pageinfo.pageNum = 1
        this.getOfrResourceList()
        // if(this.search) {

        //   this.resList = this.resTreeList.filter(data => !this.search || data.remarks.toLowerCase().includes(this.search.toLowerCase()))
        // }else {
          // this.resList = this.currentChangePage(this.pageinfo.pageSize, 1)
        // }
      },
      // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //   if (columnIndex === 0) {
      //     if (row.span) {
      //       return {
      //         rowspan: row.length,
      //         colspan: 1
      //       };
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0
      //       };
      //     }
      //   }
      //   this.tableLoading = false
      // },
      handleResSelectionChange(selection) {
        if(this.resSelectSingle) {
          return
        }
        this.ofrResourceIds = JSON.parse(JSON.stringify(selection)).map(item => item.ofrResourceId)
      },
      clickRowRes(row) {
        if(this.resSelectSingle) {
          this.singleResId = row.ofrResourceId
          return
        }
        this.$refs.restypeTable.toggleRowSelection(row)
      },
      // //指定列求和
      // getSummaries(param, sumsArr) {
      //   // console.log(param);
      //   // console.log(sumsArr);
      //   const { columns, data } = param;
      //   const sums = [];
      //   columns.forEach((column, index) => {
      //     if (index === 0) {
      //       sums[index] = "合计";
      //       return;
      //     }
      //     const values = data.map((item) => Number(item[column.property]));
      //     sumsArr.forEach(item => {
      //       if(column.property == item) {
      //         sums[index] = values.reduce((prev, curr) => {
      //           const value = Number(curr);
      //           if (!isNaN(value)) {
      //             return (Number(prev) + Number(curr)).toFixed(2);
      //           } else {
      //             return prev;
      //           }
      //         }, 0);
      //       }
      //     })
      //   });
      //   return sums;
      // },

      initBomsort (array) {
        if (array && array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            array[i].bomsort = this.bomsort++
            if(array[i].children && array[i].children.length > 0){
              this.initBomsort(array[i].children)
            }
          }
        }
      },
      // 批量编辑
      handleEditBatch() {
        this.bomsort = 0
        this.$confirm('此操作将批量编辑BOM, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(111)
          let data = JSON.parse(JSON.stringify(this.tableData))
          this.initBomsort(data)
          const flattenedArray = this.getOneArr(data).map((item, index) => {
            return {
              bomId: item.bomId,
              quantity: item.quantity,
              price: item.price,
              lossRate: item.lossRate,
              remark: item.remark,
              jc: item.jc,
              sort: item.sort,
              bomsl: item.bomsl,
              bzslmdw: item.bzslmdw,
              bomsort: item.bomsort
            }
          });
          // console.log(JSON.parse(JSON.stringify(flattenedArray)));
          this.isLoading = true
          this.$http.post(url.editBomBatch, flattenedArray).then(res => {
            // console.log(res);
            this.isLoading = false
            if(res.data.code === 200) {
              this.$message.success(res.data.msg)
              this.getList()
            }
          })
        }).catch(() => {
        });

      },
      // 批量删除
      handleDelBatch() {
        this.$confirm('此操作将批量删除BOM, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let bomIds = this.ids.toString()
          this.$http.post(url.removeBomBatch + bomIds).then(res => {
            if(res.data.code === 200) {
              this.$message.success(res.data.msg)
              this.getList()
            }
          })
        }).catch(() => {
        });

      },
      // 减行
      handleDelete(row, index) {
        this.bomData.splice(index, 1)
      },
      clickP(pid, index) {
        this.dialogPVisible = true
        this.pid1 = pid
        this.index = index
      },
      submitP() {
        this.bomData[this.index].pid = this.pid1
        this.bomData[this.index].pName = this.getPName(this.pid1)
        this.dialogPVisible = false
      },
      openResDialog(single = false, isXpj = false) {
        this.dialogResVisible = true
        this.resSelectSingle = single
        this.isXpj = isXpj
        this.pageinfo.pageNum = 1
        this.resSortDime = null
        this.$nextTick(() => {
          if(this.$refs.restypeTable) {
            this.$refs.restypeTable.clearSelection()
            this.$refs.restypeTable.clearSort()
          }
        })
        this.cbRestypeId = this.resTypeList[0]?.cbRestypeId
        this.cbussDimeTree = []
        this.resDimeList = []
        this.getOfrResourceList()
        this.getCbussDimeList()
        if(single) {
          this.singleResId = this.ruleForm.ofrResourceId || null
        }else {
          this.singleResId = null
          this.ofrResourceIds = []
        }
      },
      clickRes() {
        this.openResDialog(false, false)
      },
      submitRes() {
        if(this.resSelectSingle) {
          if(!this.singleResId) {
            this.$message.warning('请选择资源')
            return
          }
          this.ruleForm.ofrResourceId = this.singleResId
          this.dialogResVisible = false
          return
        }
        this.dialogResVisible = false
        if(this.isXpj) {
          // console.log(this.ofrResourceIds);
          this.handleXpj()
        }else {
          if(this.$refs.restypeTable && this.$refs.restypeTable.selection) {
            this.ofrResourceIds = this.$refs.restypeTable.selection.map(item => item.ofrResourceId)
          }
          this.ofrResourceIds.forEach(item => {
            this.bomData.push({
              pid: this.pid,
              pName: this.pName,
              rid: this.contentData.ofrResourceId,
              ofrResourceId: item,
              quantity: null,
              ggxh: this.getOfrResource(item, 'ggxh'),
              jldw: this.getOfrResource(item, 'jldw'),
              price: this.getOfrResource(item, 'rprice'),
              remark: null,
              lossRate: null,
              addChild: true,
              ofrResourceName: this.getOfrResource(item, 'remarks'),
              bomsl: null,
              bzslmdw: null,
              xpj: '1'
            })
          })
        }

      },
      getOfrResource(ofrResourceId, key) {
        let obj = {}
        this.resTreeList.forEach(item => {
          // if(item.resourceList){
          //   item.resourceList.forEach(val => {
              if(item.ofrResourceId == ofrResourceId) {
                obj = item
              }
          //   })
          // }

        })
        return obj[key] ? obj[key] : null
      },
      // bom导入
      handleImport() {
        // this.loadProgress = 0
        // this.progressFlag = false
        this.dialogImportVisible = true
      },
      handleExport(){
        const loading = this.$loading({
          lock: true,
          text: '下载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        this.$http({
          url: url.bomExport + this.contentData.ofrResourceId,
          method: 'post',
          responseType: 'blob',
          headers: {            //注意
            'Content-Type': 'application/json; application/octet-stream'
          }
        }).then(res => {
          // console.log(res);
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', `BOM导出${new Date().getTime()}.xls`);
          document.body.appendChild(link);
          link.click();
          loading.close();
        })
      },
      handleImportZnhw() {
        // this.loadProgress = 0
        // this.progressFlag = false
        this.dialogImportZnhwVisible = true
      },
      // 下载模板
      exportBtn() {
        // this.$http.get(url.importTemplate + this.ofoFlowWork.ofoFlowWorkId).then(res => {
        //   console.log(res);
        //   console.log(this.$base_url);
        //   if(res.data.code == 200) {
        //     // window.open(this.$base_url + res.data.msg, '_self')
        //   }

        // })
        const loading = this.$loading({
          lock: true,
          text: '下载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        this.$http({
          url: url.importBomTemplate,
          method: 'post',
          responseType: 'blob',
          headers: {            //注意
            'Content-Type': 'application/json; application/octet-stream'
          }
        }).then(res => {
          // console.log(res);
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', `BOM导入模板${new Date().getTime()}.xls`);
          document.body.appendChild(link);
          link.click();
          loading.close();
        })
      },
      exportBtnZnhw() {
        // this.$http.get(url.importTemplate + this.ofoFlowWork.ofoFlowWorkId).then(res => {
        //   console.log(res);
        //   console.log(this.$base_url);
        //   if(res.data.code == 200) {
        //     // window.open(this.$base_url + res.data.msg, '_self')
        //   }

        // })
        const loading = this.$loading({
          lock: true,
          text: '下载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        this.$http({
          url: url.importBomTemplateZnhw,
          method: 'post',
          responseType: 'blob',
          headers: {            //注意
            'Content-Type': 'application/json; application/octet-stream'
          }
        }).then(res => {
          // console.log(res);
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', `BOM导入模板${new Date().getTime()}.xls`);
          document.body.appendChild(link);
          link.click();
          loading.close();
        })
      },
      handleChange(file) {
        const loading = this.$loading({
          lock: true,
          text: '导入中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        // this.progressFlag = true
        const formData = new FormData()
        formData.append('file', file.raw)
        formData.append('rid', this.contentData.ofrResourceId)
        // let time = new Date().getTime() + Math.random()
        // formData.append('key', time)
        // this.getProgress(time)
        this.$http.post(url.importBomData + this.contentData.ofrResourceId + '/' + (this.bomHeader.id || 0),
          formData
        ).then(res => {
          loading.close();
          if(res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.dialogImportVisible = false
            this.getList()
          }
        })
      },
      handleZnhwChange(file) {
        const loading = this.$loading({
          lock: true,
          text: '导入中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        // this.progressFlag = true
        const formData = new FormData()
        formData.append('file', file.raw)
        formData.append('rid', this.contentData.ofrResourceId)
        // let time = new Date().getTime() + Math.random()
        // formData.append('key', time)
        // this.getProgress(time)
        this.$http.post(url.importBomDataZnhw + this.contentData.ofrResourceId,
          formData
        ).then(res => {
          loading.close();
          if(res.data.code == 200) {
            this.$message.success(res.data.msg)
            this.dialogImportZnhwVisible = false
            this.getList()
          }
        })
      },
      judgeButton(type) {
        return this.currentMenu.perms.some(item => item.menuType == 'F' && item.perms == `${this.currentMenu.kind}:${type}`)
      },
      judgeButton2 (type) {
        return this.btnMenu.some(item => item.perms === type)
      },
      getResTypeResource() {
        this.$http.get(url.resTypeResource + '?kind=' + this.contentData.kind).then(res => {
          // console.log(res);
          if(res.data.code == 200) {
            // this.resTreeList = res.data.data.filter(item => item.resourceList).map((item, index) => {
            //   return {
            //     ...item,
            //     index: index
            //   }
            // })
            this.resTypeList = res.data.data.filter(item => item.resourceList)
            // this.resTypeList.unshift({
            //   cbRestypeId: 0,
            //   name: '全部',
            //   resourceList: []
            // })
            res.data.data.filter(item => item.resourceList).forEach(item => {
              item.resourceList.forEach((val, index) => {
                this.resTreeList.push({
                  restypeName: item.name,
                  ...val,
                })
              })
            })
            // this.resList = JSON.parse(JSON.stringify(this.resTreeList))
            // this.resList = this.currentChangePage(this.pageinfo.pageSize, this.pageinfo.pageNum)
            // this.pageinfo.total = this.resTreeList.length

          }
        })
      },
      // 拿资源维度列表
      getList() {
        this.tableData = []
        this.expandedRowKeys = new Set()
        this.loading = true
        this.options = []
        this.xhMaxLen = 0
        this.$http.get(url.bomResource + this.contentData.ofrResourceId).then(res => {
          this.tableData = this.$handleTree(res.data.data, 'bomId', 'pid')
          this.initXh(null, this.tableData, 0)
          console.log(this.xhMaxLen)
          this.xhMaxLen = (this.xhMaxLen * 11 + 20) < 100 ? 100 : this.xhMaxLen * 11 + 20
          console.log(this.xhMaxLen)
          const data = {bomId: 0, name: '顶级节点', children: []};
          data.children = this.tableData;
          this.options.push(data)
          this.loading = false
          this.originalData = JSON.parse(JSON.stringify(this.tableData))

          this.initSortable()
          // console.log(JSON.parse(JSON.stringify(this.tableData)));
        })
        if(!this.bomHeader || !this.bomHeader.id){
          this.getDefaultBomHeader()
        }
      },
      getDefaultBomHeader(){
        this.$http.get(url.defaultBomHeader + this.contentData.ofrResourceId).then(res => {
         this.bomHeader = res.data.data || {}
        })
      },
      handleBomHeader() {
        this.dialogBomHeaderVisible = true
        this.selectedBomHeaderId = this.bomHeader && this.bomHeader.id ? this.bomHeader.id : null
        this.getBomHeaderList()
      },
      getBomHeaderList() {
        this.bomHeaderLoading = true
        this.$http.get(url.bomHeaderList + this.contentData.ofrResourceId).then(res => {
          if(res.data.code === 200) {
            this.bomHeaderList = res.data.data || []
            if(!this.selectedBomHeaderId && this.bomHeaderList.length) {
              const defaultRow = this.bomHeaderList.find(item => item.isDefault === 'Y')
              this.selectedBomHeaderId = defaultRow ? defaultRow.id : this.bomHeaderList[0].id
            }
          }
        }).finally(() => {
          this.bomHeaderLoading = false
        })
      },
      submitChangeBomHeader() {
        if(!this.selectedBomHeaderId) {
          this.$message.warning('请选择要切换的版本')
          return
        }
        if(this.bomHeader && this.bomHeader.id === this.selectedBomHeaderId) {
          this.dialogBomHeaderVisible = false
          return
        }
        this.$http.post(url.changeBomHeader + this.selectedBomHeaderId).then(res => {
          if(res.data.code === 200) {
            this.$message.success(res.data.msg || '版本切换成功')
            this.dialogBomHeaderVisible = false
            this.bomHeader = {}
            this.getList()
          }
        })
      },
      submitCreateBomHeader() {
        if(!this.selectedBomHeaderId) {
          this.$message.warning('请选择版本')
          return
        }
        this.$http.post(url.createBomHeader + this.selectedBomHeaderId).then(res => {
          if(res.data.code === 200) {
            this.$message.success(res.data.msg || '生成新版本成功')
            this.dialogBomHeaderVisible = false
            this.bomHeader = {}
            this.getList()
          }
        })
      },
      // 初始化序号
      initXh (index, array, len) {
        if (array && array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            array[i].xh = (index ? index + '-' : '') + (i + 1)
            this.xhMaxLen = this.xhMaxLen > array[i].xh.length + len ? this.xhMaxLen : array[i].xh.length + len
            if(array[i].children && array[i].children.length > 0){
              this.initXh(array[i].xh, array[i].children,array[i].xh.length + len)
            }
          }
        }
      },
      /** 转换数据结构 */
      normalizer(node) {
        // this.$nextTick(() => {
          if (node.children && !node.children.length) {
            delete node.children;
          }
          return {
            id: node.bomId,
            label: node.name,
            children: node.children
          };
        // })
      },
      // inquire() {
      //   this.pageNum = 1
      //   this.getList()
      // },
      reset() {
        this.ruleForm = {
          ofrResourceId: null,
          pid: 0,
          price: null,
          quantity: null,
          bomsl: null,
          bzslmdw: null,
          remark: null,
          rid: this.contentData.ofrResourceId,
          lossRate: null,
          jc: null
        }
      },
      // 表格选中框事件
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.bomId)
        // this.edit = rows.length === 1
        // this.del = rows.length
      },
      // 表格的修改按钮
      handleEdit(row) {
        if(this.$refs.ruleForm) {
          this.$nextTick(() => {
            // 清除表单校验效果
            this.$refs.ruleForm.clearValidate();
          })
        }
        const id = row.bomId || this.ids[0]
        this.title = `修改BOM`
        this.dialogFormVisible = true
        this.$http.get(url.bomDetail + id).then(res => {
          if(res.data.code === 200) {
            this.ruleForm = res.data.data
            this.ruleForm.ofrResourceIds = []
          }
        })
      },
      // 表格的删除按钮
      handleDel(row) {
        // this.selected = row
        const ids = row.bomId || this.ids.toString()
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(url.removeBomResource + ids).then(res => {
            if(res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getList()
            }
          })

        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            // console.log(this.ruleForm);
            // let dimes = []
            // if(this.formList.length != 0) {
            //   dimes = this.handleDimes(this.formList)
            // }
            let query = JSON.parse(JSON.stringify(this.ruleForm))
            query.ofrResourceIds = query.ofrResourceIds.toString()
            if(!this.ruleForm.bomId) {
            //   // console.log(1111);
              // this.$http.post(url.addBomBatch, query).then(res => {
              //   // console.log(res);
              //   this.isLoading = false
              //   if(res.data.code === 200) {
              //     this.$message.success(res.data.msg)
              //     this.dialogFormVisible = false
              //     this.getList()
              //   }
              // })
            }else {
              // console.log(22222222222);
              this.$http.post(url.editBomResource, query).then(res => {
                this.isLoading = false
                if(res.data.code === 200) {
                  this.$message.success(res.data.msg)
                  this.dialogFormVisible = false
                  this.getList()
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      submitForm1() {
        this.isLoading = true
        this.$http.post(url.addBomBatch + (this.bomHeader.id || 0), this.bomData).then(res => {
          // console.log(res);
          this.isLoading = false
          if(res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.dialogAddVisible = false
            this.getList()
          }
        })
      },
      submitCopyForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            this.$http.post(url.copyBom + (this.bomHeader.id || 0), this.formCopy).then(res => {
              // console.log(res);
              this.isLoading = false
              if(res.data.code === 200) {
                this.$message.success(res.data.msg)
                this.dialogCopyVisible = false
                this.getList()
              }
            })
          } else {
            return false;
          }
        });
      },
      handleAdd(row) {
        this.title = `新增Bom`
        // this.$nextTick(() => {
        //   // 清除表单校验效果\
        //   this.$refs.ruleForm.clearValidate();
        // })
        this.pid = row.bomId
        this.pName = this.getPName(row.bomId)
        this.bomData = []
        this.dialogAddVisible = true
        // this.reset()
        // if(row) {
        //   this.ruleForm.pid = row.bomId
        // }
      },
      getPName(bomId) {
        let data = JSON.parse(JSON.stringify(this.options))
        const flattenedArray = this.getOneArr(data);
        let name = ''
        flattenedArray.forEach(item => {
          if(item.bomId == bomId) {
            name = item.name
          }
        })
        return name
      },
      getOneArr (data) {
        let newData = []
        const callback = (item) => {
          (item.children || (item.children = [])).map(v => {
            callback(v)
          })
          delete item.children
          newData.push(item)
        }
        data.map(v => callback(v))
        return newData.reverse()
      },
      handleCopy() {
        this.$nextTick(() => {
        // console.log(this.$refs);
          // 清除表单校验效果\
          if(this.$refs.formCopy) {
            this.$refs.formCopy.clearValidate();
          }
        })
        this.dialogCopyVisible = true
        this.formCopy = {
          ofrResourceId: "",
          rid: this.contentData.ofrResourceId
        }
        this.$http.get(url.copyBomResources).then(res => {
          // console.log(res);
          if(res.data.code === 200) {
            this.copyFormResources = res.data.data
          }
        })
      },
      handleSizeChange(val) {
        this.pageinfo.pageSize = val
        this.pageinfo.pageNum = 1
        // this.resList = this.currentChangePage(val, this.pageinfo.pageNum)
        this.getOfrResourceList()
      },
      handleCurrentChange(val) {
        this.pageinfo.pageNum = val
        // this.resList = this.currentChangePage(this.pageinfo.pageSize, val)

        this.getOfrResourceList()
      },
      currentChangePage(size, current) {
        const tablePush = [];
        var array = []
        if(this.search) {
          array = this.resTreeList.filter(data => !this.search || data.remarks.toLowerCase().includes(this.search.toLowerCase()))
        }else {
          array = JSON.parse(JSON.stringify(this.resTreeList));
        }
        array = this.cbRestypeId ? array.filter(item => item.cbRestypeId == this.cbRestypeId) : array
        this.pageinfo.total = array.length
        array.forEach((item, index) => {
          if (size * (current - 1) <= index && index <= size * current - 1) {
            tablePush.push(item);
          }
        });
        return tablePush;
      },
    },
    watch: {
      contentData(newValue, oldValue) {
        // console.log(newValue);
        this.bomHeader = {}
        this.bomHeaderList = []
        this.selectedBomHeaderId = null
        this.getList()

      }
    },
  }
</script>

<style lang="scss" scoped>
.tab1 {
  .el-table {
    margin-bottom: 39px;
  }
}
.right-input {
  ::v-deep .el-input__inner {
    text-align: right;
  }
}
::v-deep .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
  /* text-align: right; */
  padding-right: 15px
}
/* ::v-deep .el-dialog__body {
  padding: 30px 0 30px 20px;
} */
 .res-dialog {
  ::v-deep .el-dialog {
    margin: 0 auto;
    max-height: calc(100% - 72px);
    height: auto;
  }
  ::v-deep .el-dialog__body {
    padding: 10px 20px 10px 20px;
    max-height: calc(100vh - 211px);
    height: auto;
    overflow: auto;
  }
 }
.left {
  width: 180px;
  overflow: auto;
  height: calc(100vh - 330px);
  /* flex-shrink: 0; */
  /* max-height: calc(100vh - 100px); */
  /* background: pink; */
  margin-right: 10px;
  ::v-deep .el-collapse-item__content {
    padding-bottom: 8px;
  }
  ::v-deep .el-collapse-item__header {
    height: 30px;
    line-height: 30px;
  }
}
.drag-handle {
  cursor: move;
  margin-right: 8px;
  font-weight: bold;
  color: #409EFF;
}

.sortable-ghost {
  opacity: 0.7;
  background: #e6f7ff;
}
</style>
